import { map } from 'es-toolkit/compat';

import { AnnotationAssignment } from 'interfaces/annotation';
import { DisplayedField } from 'interfaces/genericFields';

export interface AnnotationAssignmentFieldContext {
  tagOptions: string[];
}

export const idField: DisplayedField<AnnotationAssignment, number, AnnotationAssignmentFieldContext> = {
  filterType: 'multiSelect',
  dataKey: 'annotationAssignmentId',
  label: 'ID',
  columnWidth: { width: 90 },
};

export const nameField: DisplayedField<AnnotationAssignment, string, AnnotationAssignmentFieldContext> = {
  filterType: 'text',
  dataKey: 'name',
  label: 'Name',
  columnWidth: { width: 200 },
};

export const tagsField: DisplayedField<AnnotationAssignment, string[], AnnotationAssignmentFieldContext> = {
  cellEditType: 'multiText',
  filterType: 'multiText',
  dataKey: 'tags',
  label: 'Tags',
  columnWidth: { width: 250 },
  sortable: false,
  optionsGetter: (context) => map(context?.tagOptions, (value) => ({ value, label: value })),
};

export const annotationAssignmentFields: Array<
  DisplayedField<AnnotationAssignment, any, AnnotationAssignmentFieldContext>
> = [idField, nameField, tagsField];
